import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'
import { useState, useEffect } from 'react'
import { RiCheckboxLine, RiCheckboxBlankLine } from 'react-icons/ri'

// helper functions
import {
  returnValue,
  returnUserContent,
  returnBlockValue,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

const Component = ({ id, index, todo, content }) => {
  const [completed, setCompleted] = useState(todo.todo_completed)
  const [getUserContents, setUserContents] = useAtom(userContents)

  function toggleCompleted() {
    const nextState = produce(getUserContents, draft => {
      if (completed == 'true') {
        draft[id]['todos'][index] = 'false'
        setCompleted('false')
      } else {
        draft[id]['todos'][index] = 'true'
        setCompleted('true')
      }
    })
    setUserContents(nextState)
  }

  return (
    <div
      key={index}
      onClick={toggleCompleted}
      className={Classnames(
        'flex cursor-pointer hover:line-through space-x-2 items-center',
        {
          'line-through opacity-50':
            returnUserContent('todos', id, getUserContents)[index] == 'true',
        }
      )}
    >
      <span>
        {returnUserContent('todos', id, getUserContents)[index] == 'true' && (
          <RiCheckboxLine />
        )}
        {returnUserContent('todos', id, getUserContents)[index] == 'false' && (
          <RiCheckboxBlankLine />
        )}
        {!returnUserContent('todos', id, getUserContents)[index] && (
          <RiCheckboxBlankLine />
        )}
      </span>

      <span className="font-medium">{todo.todo_text}</span>
    </div>
  )
}

export default Component
